<template>
  
    <v-layout row wrap class="section6">
        <v-flex xs12 sm2 >
        </v-flex>
        <v-flex xs12 sm3 >
            <v-card flat tile class="transparent text-xs-left" :style="footerStyle">
                <v-card-text>
                <div class="subheading white--text font-weight-bold">LEGAL </div>
                <div class="grey--text font-weight-light" style="cursor:pointer;">
                    <div @click="OpenWindow('https://termify.io/privacy-policy/1606608272')">Privacy Policy </div>
                    <div @click="OpenWindow('https://termify.io/terms-and-conditions/1606611371')">Terms & Conditions</div>
                    <div @click="OpenWindow('https://termify.io/disclaimer/1606610150')">Disclaimer</div>
                    <div @click="OpenWindow('https://termify.io/cookie-policy/1606609423')">Cookie Policy</div>
                    <div @click="OpenWindow('https://termify.io/eula/1606610609')">EULA Policy</div>
                    <div @click="OpenWindow('https://termify.io/return-and-refund-policy/1606610934')">Return & Refund Policy</div>
                </div>
                </v-card-text>
            </v-card>
        </v-flex>
        <v-flex xs12 sm3 >
            <v-card flat tile class="transparent text-xs-left" :style="footerStyle">
            <v-card-text>
                <div class="subheading white--text font-weight-bold">CONTACT US</div>
                <div class="grey--text font-weight-light" style="cursor:pointer;">
                    <div @click="OpenWindow('mailto:support@sweldonow.ph')">
                        <v-icon color="grey" small dark>email</v-icon>&nbsp;support@sweldonow.ph
                    </div>
                </div>
                </v-card-text>
            </v-card>
        </v-flex>
        <v-flex xs12 sm3 >
            <v-card flat tile class="transparent text-xs-left" :style="footerStyle">
            <v-card-text>
                <div class="subheading white--text font-weight-bold" @click="$router.push('/support')" style="cursor:pointer;">SUPPORT</div>
                <div class="grey--text font-weight-light" style="cursor:pointer;">
                    <div @click="$router.push('/faq')">FAQ</div>
                    <div @click="$router.push('/support')">Report Issue</div>
                    <div @click="$router.push('/support')">Other Concerns</div>
                </div>
                </v-card-text>
            </v-card>
        </v-flex>
        
        <v-layout align-center row wrap class="section7">
            <v-flex xs12 sm6 style="margin:20px 0px 20px 0px;">
                <div v-if="isMobile" class="text-xs-center">
                    <v-btn v-for="icon in icons" :key="icon" class="white--text" :title="icon.title" icon @click="OpenWindow(icon.link)">
                        <v-icon size="24px">{{ icon.icon }}</v-icon>
                    </v-btn>
                </div>
                <div v-if="!isMobile">
                    <v-btn v-for="icon in icons" :key="icon" class="white--text" :title="icon.title" icon @click="OpenWindow(icon.link)">
                        <v-icon size="24px">{{ icon.icon }}</v-icon>
                    </v-btn>
                </div>
            </v-flex>
            <v-flex xs12 sm6>
                <v-card v-if="isMobile" flat tile class="transparent white--text text-xs-center">
                <v-card-text class="grey--text">
                    <div style="margin:20px 15px 20px 0px;">&copy;2023 - SweldoNow</div>
                </v-card-text>
                </v-card>
                <v-card v-if="!isMobile" flat tile class="transparent white--text text-xs-right">
                <v-card-text class="grey--text">
                    <div style="margin:20px 15px 20px 0px;">&copy;2023 - SweldoNow</div>
                </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-layout>

</template>
<script>
export default {
    data() {
        return {
            icons: [
              {icon: 'fab fa-facebook', link: 'https://www.facebook.com/Accureos-101753728463338', title: 'SweldoNow Facebook page'},
            //  {icon: 'fab fa-youtube', link: 'https://www.youtube.com/channel/UCSlaGhEXs2hMiWthvmOzWAg', title: 'Accureos Youtube channel'},
            //   {icon: 'fab fa-twitter', link: ''},
            //   {icon: 'fab fa-google-plus', link: ''},
            //   {icon: 'fab fa-linkedin', link: ''},
            //   {icon: 'fab fa-instagram', link: ''}
            ]
        }
    },
    methods: {    
        OpenWindow(url) {
            if (url!='') window.open(url, '_blank')
        }    
    },
    computed: {
        isMobile() {
            return window.innerWidth < 600
        },
        footerStyle() {
            return this.isMobile ? "margin:5px 10px 0px 20px;" : "margin:30px;"
        }
    },
    created() {
    }
}
</script>
<style scoped>
.section6{
    background-color:#212121;
    height:auto;
}
.section7{
    background-color:#000000;
    height:auto;
}
</style>